import {
  GridOnOutlined,
  ImageOutlined,
  InsertDriveFileOutlined,
  PictureAsPdfOutlined,
} from "@mui/icons-material";

import { isSpreadsheetFile } from "./isSpreadsheetFile";

/**
 * FileIcon
 * Renders an icon based on the file's MIME type (and optional file name).
 */
const FilePreviewImageTypeIcon = ({
  contentType,
  fileName,
  size = 48,
  color = "text.secondary",
}) => {
  if (contentType?.startsWith("image/")) {
    return <ImageOutlined className="thin" sx={{ fontSize: size, color }} />;
  }
  if (contentType === "application/pdf") {
    return (
      <PictureAsPdfOutlined className="thin" sx={{ fontSize: size, color }} />
    );
  }
  if (isSpreadsheetFile({ content_type: contentType, fileName })) {
    return (
      <GridOnOutlined
        className="thin"
        sx={{ fontSize: size, color: color === "text.secondary" ? "#15803d" : color }}
      />
    );
  }
  return (
    <InsertDriveFileOutlined className="thin" sx={{ fontSize: size, color }} />
  );
};

export default FilePreviewImageTypeIcon;
